/// <amd-module name="Wit/Common/QueryUtils/Models" />
import { ObservableValue } from "VSS/Core/Observable";
import { ILinkProps } from "VSSUI/Link";
import { ITreeItem } from "VSSUI/Utilities/TreeItemProvider";
import { QueryHierarchyItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";

export interface EmptyItem {
    isEmptyFolderContext: true;
    isLoadingContext: boolean;
}

export interface ExtendedHierarchyItem extends QueryHierarchyItem {
    isFavorite?: boolean;
}

export interface ExtendedQueryHierarchyItem extends ExtendedHierarchyItem {
    isEmptyFolderContext: false;
    isLoadingContext: false;
}

export interface QueryFavoriteItemsGroup {
    id: string;
    name: string;
    items: ExtendedHierarchyItem[];
}

export interface ObservableFavoriteItemsGroup {
    id: string;
    name: string;
    items: QueryItem[];
}

export interface QueryItem extends ExtendedQueryHierarchyItem {
    depth: number;
    isFavoriteObservable: ObservableValue<boolean>;
    linkProps?: ILinkProps;
}

export interface IQueryListProviderResponse {
    queryFavoriteGroups: QueryFavoriteItemsGroup[];
    allItems: ExtendedHierarchyItem[];
    queryItem?: QueryHierarchyItem;
}

export enum QuerySaveDialogMode {
    NewQuery,
    NewFolder,
    RenameQuery,
    RenameFolder,
    SaveAs
}

export interface QueryTreeItem extends ITreeItem<ExtendedQueryHierarchyItem> {
    children: QueryTreeItem[];
    depth: number;
}
